import { render, staticRenderFns } from "./SigaInstance.vue?vue&type=template&id=5e9894ea"
import script from "./SigaInstance.vue?vue&type=script&lang=js"
export * from "./SigaInstance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports